import React from 'react'
import ReactMarkdown from 'react-markdown'
import 'app/gears/announcements/style/announcements.scss'

function Announcement({ announcement }) {
  const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  const isNewAnnouncement = announcement.beginDate > oneWeekAgo
  return <article>
    <h2>{isNewAnnouncement && <span className='new-announcement'>(New) </span>}{announcement.headline}</h2>
    <h4>{announcement.author}</h4>
    <h4>{(new Date(announcement.beginDate)).toLocaleDateString()}</h4>
    <ReactMarkdown source={announcement.body} />
  </article>
}

export default Announcement